export class Impresoras {
  public id: number;
  public impresoraCode: string;
  public description: string;
  public distributionList: string;
  public lote: number;
  public estado: boolean = true;
  public fecCreacion: Date = new Date();
  public usrCreacion: string;
  public fecModif: Date;
  public usrModif: string = '';
  public isAdd: boolean;
  public isEdit: boolean;
  public originalData: Impresoras;

  static transformData(data: Impresoras): Impresoras {
    // Convert date strings from response to Date type
    data.fecCreacion = new Date(data.fecCreacion);
    if (data.fecModif) {
      data.fecModif = new Date(data.fecModif);
    }
    return data;
  }
}
